// extracted by mini-css-extract-plugin
export default {"info":"HeaderInfo_info__ETt7c"};